(function () {
  var lastVisibilityRefresh = 0;
  var visibilityRefreshInterval = 60000;

  function setBubbleCount(count) {
    // Dawn bubble (usually: .cart-count-bubble > span)
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var spans = bubble.querySelectorAll('span');
      if (spans && spans.length) spans[0].textContent = String(count);
      bubble.style.display = count > 0 ? '' : 'none';
    });

    // If you ever use custom count nodes
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
        setBubbleCount(count);
      })
      .catch(function () {});
  }

  // Expose so other scripts (routine block) can call it
  window.sachetRefreshCartCount = refreshCartCount;

  // Refresh only when restoring a page from the back-forward cache.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCartCount();
  });

  // Refresh at most once per minute when returning to a visible tab.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;

    var now = Date.now();
    if (now - lastVisibilityRefresh < visibilityRefreshInterval) return;

    lastVisibilityRefresh = now;
    refreshCartCount();
  });

  // Optional manual event
  document.addEventListener('sachet:cart:refresh', function () {
    refreshCartCount();
  });
})();
